import React, { ReactNode } from 'react';

import ClearRoundedIcon from '@mui/icons-material/ClearRounded';
import { IconButton } from '@mui/material';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import { useThemeMode } from '../../providers/ThemeModeProvider';

export interface ModalProps {
  open: boolean;
  title?: string;
  onClose: () => void;
  content: ReactNode;
  fullWidth?: boolean;
  ignoreBackdropClick?: boolean;
  closeIcon?: boolean;
  withoutPadding?: boolean;
  paddingForTitle?: string | number;
}

export const Modal = ({
  open,
  title,
  onClose,
  content,
  fullWidth,
  ignoreBackdropClick,
  closeIcon,
  withoutPadding,
  paddingForTitle,
}: ModalProps) => {
  const { themeMode } = useThemeMode();

  const bgcolor = themeMode === 'light' ? 'grey.200' : 'grey.800';

  if (!open) {
    return null;
  }

  const paddingTitle = () => {
    if (paddingForTitle) {
      return paddingForTitle;
    }
    if (withoutPadding) {
      return 0;
    }
    return 4;
  };

  return (
    <Dialog
      fullWidth={fullWidth}
      open
      sx={{
        '.MuiPaper-root': {
          borderRadius: '12px',
        },
      }}
      onClose={() => {
        if (!ignoreBackdropClick) {
          onClose();
        }
      }}
    >
      <Box display="flex" justifyContent="space-between" sx={{ bgcolor }}>
        <DialogTitle variant="h4" sx={{ bgcolor, p: paddingTitle }}>
          {title}
        </DialogTitle>
        {closeIcon && (
          <IconButton disableRipple onClick={onClose} sx={{ p: 3 }}>
            <ClearRoundedIcon fontSize="small" />
          </IconButton>
        )}
      </Box>
      <Box sx={{ bgcolor }}>
        <DialogContent sx={{ pt: 1, p: withoutPadding ? 0 : 4 }}>{content}</DialogContent>
      </Box>
    </Dialog>
  );
};
